import * as axiosService from "./axiosService";


export const savePreferences = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Supplier/SetPreferences`, payload);
};

export const getUserPreferences = () => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Supplier/GetPreferences`);
};

export const changePinDetails = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/User/ChangePin`, payload);
};

export const getLanguageMaster = () => {
  return axiosService.Get(
    process.env.REACT_APP_MASTER_DATA_API_URL + `/getLanguageMaster?lang=EN`
  );
};

export const updatePreferredLanguage = (payload) => {
  return axiosService.Post(
    process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/UpdatePreferredLanguage`,
    payload
  );
};

export const getShipperListForInternalSourcer = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Supplier/GetShipperListForInternalSourcerPreferences`,payload);
};